import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './components/admin/admin.component';
import { DepartmentTabsComponent } from './components/admin/department-tabs.component';
import { TicketSubType } from './components/configuration/ticketSubType.component';
import { TicketTypeSearch } from './components/configuration/ticketType-search.compnent';
import { CreateTicketType } from './components/configuration/ticketType.component';
import { UploadJapanCountryDataComponent } from './components/configuration/upload-japan-country-data.component';
import { ReportsComponent } from './components/reports/reports.component';
import { DepartmentsSearchComponent } from './components/department/department-search.component';
import { AssignOrRetractDepartmentUserComponent } from './components/department/department-user-assign-or-retract.component';
import { DepartmentUserSearchComponent } from './components/department/department-user-search.component';
import { DepartmentUserViewComponent } from './components/department/department-user-view.component';
import { DepartmentViewComponent } from './components/department/department-view.component';
import { DepartmentComponent } from './components/department/department.component';
import { DisputeTicketsComponent } from './components/dispute-tickets.component';
import { DynamicTabsComponent } from './components/dynamic-tabs.component';
import { EmailTicketsComponent } from './components/email-tickets.component';
import { FBODetailComponent } from './components/fbodetail.component';
import { FBOProfileComponent } from './components/fboprofile.component';
import { FileUploadsComponent } from './components/file-uploads/file-uploads.component';
import { KnowledgeBaseComponent } from './components/knowledgebase.component';
import { OrderPromotionSummaryComponent } from './components/order-promotion-summary.component';
import { OrderHistoryComponent } from './components/orderhistory.component';
import { OrderTabsComponent } from './components/orders/order-tabs.component';
import { PaymentStatusComponent } from './components/payments/payment-status.component';
import { PosOrderTabsComponent } from './components/pos-orders/pos-order-tab.component';
import { ProductTicketsComponent } from './components/product-tickets.component';
import { UplineReportComponent } from './components/reports/upline-report.component';
import { RetailProfileComponent } from './components/retail-profile.component';
import { RetailComponent } from './components/retail.component';
import { TicketCreateComponent } from './components/ticket-create.component';
import { TicketsDashboardComponent } from './components/ticket-dashboard.component';
import { TicketsComponent } from './components/tickets.component';
import { ViewWorkTicketComponent } from './components/view-work-ticket.component';
import { WorkTicketsComponent } from './components/work-tickets.component';
import { EmailConfigurationComponent } from './components/department/email-configuration.component';
import { EmailSignatureComponent } from './components/department/email-signature.component';
import { FdTicketsComponent } from './components/fd-tickets.component';
import { SearchComponent } from './components/search.component';

const customerServiceRoutes: Routes = [
  { path: 'search/:id', component: DynamicTabsComponent, data: { breadcrumb: 'Search' } },
  { path: 'customerservice/tickets', component: TicketsComponent, data: { breadcrumb: 'Tickets' } },
  { path: 'customerservice/knowledgebase', component: KnowledgeBaseComponent, data: { breadcrumb: 'Knowledge Base' } },
  { path: 'customerservice/fboprofile', component: FBOProfileComponent, data: { breadcrumb: 'FBO Profile' } },
  { path: 'customerservice/fbodetail', component: FBODetailComponent, data: { breadcrumb: 'FBO Detail' } },
  { path: 'customerservice/orderhistory', component: OrderHistoryComponent, data: { breadcrumb: 'Order History' } },
  { path: 'customerservice/retail', component: RetailComponent, data: { breadcrumb: 'Retail Customer Information' } },
  { path: 'customerservice/retailprofile', component: RetailProfileComponent, data: { breadcrumb: 'Retail Customer Profile' } },
  { path: 'customerservice/tickets/create', component: TicketCreateComponent, data: { breadcrumb: 'Ticket Create' } },
  { path: 'customerservice/ticket/dashboard', component: TicketsDashboardComponent, data: { breadcrumb: 'Ticket Dashboard' } },
  { path: 'customerservice/ticket/dashboard/worktickets', component: WorkTicketsComponent, data: { breadcrumb: 'Work Tickets' } },
  { path: 'customerservice/ticket/dashboard/emailtickets', component: EmailTicketsComponent, data: { breadcrumb: 'Email Tickets' } },
  { path: 'customerservice/ticket/dashboard/disputetickets', component: DisputeTicketsComponent, data: { breadcrumb: 'Dispute Tickets' } },
  { path: 'customerservice/ticket/dashboard/producttickets', component: ProductTicketsComponent, data: { breadcrumb: 'Dispute Tickets' } },
  { path: 'customerservice/ticket/dashboard/worktickets/:id', component: ViewWorkTicketComponent, data: { breadcrumb: 'View Work Ticket' } },
  { path: 'customerservice/ticket/dashboard/fdtickets', component: FdTicketsComponent, data: { breadcrumb: 'FD Ticket' } },
  { path: 'customerservice/departments/search', component: DepartmentsSearchComponent, data: { breadcrumb: 'Department Search' } },
  { path: 'customerservice/departments', component: DepartmentComponent, data: { breadcrumb: 'Create Department' } },
  { path: 'customerservice/departments/:departmentId', component: DepartmentComponent, data: { breadcrumb: 'Edit Department' } },
  { path: 'customerservice/department/:departmentId/users', component: DepartmentUserSearchComponent, data: { breadcrumb: 'Manage Department Users' } },
  {
    path: 'customerservice/department/:departmentId/assignuser', component: AssignOrRetractDepartmentUserComponent,
    data: { breadcrumb: 'Department User' }
  },
  {
    path: 'customerservice/department/:departmentId/user/:userId/edit', component: AssignOrRetractDepartmentUserComponent,
    data: { breadcrumb: 'Department User' }
  },
  {
    path: 'customerservice/department/:departmentId/user/:userId/view', component: DepartmentUserViewComponent,
    data: { breadcrumb: 'View Department User' }
  },
  { path: 'customerservice/department/:departmentId/emailConfiguration', component: EmailConfigurationComponent, data: { breadcrumb: 'Email Configuration' } },
  { path: 'customerservice/admin', component: AdminComponent, data: { breadcrumb: 'Admin' } },
  { path: 'customerservice/departmenttabs', component: DepartmentTabsComponent, data: { breadcrumb: 'Department Tabs' } },
  { path: 'customerservice/department/:departmentId/view', component: DepartmentViewComponent, data: { breadcrumb: 'Department View' } },
  { path: 'customerservice/configuration/search', component: TicketTypeSearch, data: { breadcrumb: 'Ticket Type Search' } },
  { path: 'customerservice/configuration/ticketsubtype/:ticketTypeId', component: TicketSubType, data: { breadcrumb: 'Ticket Subtypes' } },
  { path: 'customerservice/configuration/ticketType', component: CreateTicketType, data: { breadcrumb: 'Create Ticket Type' } },
  { path: 'customerservice/configuration/ticketType/:ticketTypeId', component: CreateTicketType, data: { breadcrumb: 'Edit Ticket Type' } },
  { path: 'customerservice/configuration/uploadJapanData', component: UploadJapanCountryDataComponent},
  { path: 'customerservice/orders', component: OrderTabsComponent },
  { path: 'customerservice/ordersummary/:webOrderId', component: OrderPromotionSummaryComponent, data: { breadcrumb: 'Order Summary' } },
  { path: 'customerservice/orders/:paymentProcessor/:paymentStatus', component: PaymentStatusComponent },
  { path: 'customerservice/posorders/:paymentProcessor/:paymentStatus', component: PaymentStatusComponent },
  { path: 'customerservice/orders/:webOrderId', component: OrderTabsComponent },
  { path: 'customerservice/upline', component: UplineReportComponent },
  { path: 'customerservice/posorders', component: PosOrderTabsComponent },
  { path: 'customerservice/fileuploads', component: FileUploadsComponent },
  { path: 'customerservice/reports', component: ReportsComponent },  
  { path: 'customerservice/emailsignature', component: EmailSignatureComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(customerServiceRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CustomerServiceRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/customerservice/customer-service-routing.module.ts